import {Dialog, DialogBody, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle} from './ui/dialog'
import {XMarkIcon} from '@heroicons/react/16/solid'
import {Button} from './ui/button'
import React from 'react'
import useAppStore from '@/store/useAppStore'
import useCloseToOrigin from '@/hooks/useCloseToOrigin'

interface ConfirmationModalProps {
    type?: string
    open?: boolean
    setOpen: (state: boolean) => void
}

export default function ConfirmationModal({ type, open, setOpen }: ConfirmationModalProps ) {
    const modalWindowState = useAppStore((state) => state.modalWindowState)
    const setModalWindowState = useAppStore((state) => state.setModalWindowState)
    const closeToOrigin = useCloseToOrigin()
return (
        <Dialog open={open || modalWindowState === 'opened'}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Are you sure you want to close?</DialogTitle>
                    <DialogClose>
                        <XMarkIcon onClick={()=> {
                            if (setOpen) setOpen(false)
                            setModalWindowState('closed')
                        }}/>
                    </DialogClose>
                </DialogHeader>

                <DialogBody>
                    <p>
                        You have unsaved changes in the {type} form. If you close this window, all entered data will be lost. Are you sure you want to proceed?
                    </p>
                </DialogBody>

                <DialogFooter>
                    <DialogClose asChild>
                        <Button
                            onClick={() => {
                                if (setOpen) setOpen(false)
                                setModalWindowState('closed')
                                closeToOrigin()
                            }}
                            variant="destructive">
                            Close without saving
                        </Button>
                    </DialogClose>
                    <Button
                        variant="secondary"
                        className='mr-2'
                        onClick={() => {
                            if (setOpen) setOpen(false)
                            setModalWindowState('closed')
                        }}
                    >
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
)
}
